module.exports = __webpack_public_path__ + "img/curas6.06be40ab.jpg";